export default {"src":"/_next/static/media/envelop-icon.0010aa9e.svg","height":17,"width":20,"blurWidth":0,"blurHeight":0};